import React, { useState } from 'react';
import './CodeBlock.css';

/**
 * CodeBlock Component
 * Displays syntax-highlighted code with copy functionality
 */
function CodeBlock({ code, language = 'html', copyable = true, className = '' }) {
  const [copied, setCopied] = useState(false);
  
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = code;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };
  
  return (
    <div className={`code-block ${className}`}>
      <div className="code-block-header">
        <span className="code-block-language">{language}</span>
        {copyable && (
          <button 
            onClick={handleCopy} 
            className={`copy-button ${copied ? 'copied' : ''}`}
            title="Copy to clipboard"
          >
            {copied ? (
              <>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
                Copied!
              </>
            ) : (
              <>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                </svg>
                Copy
              </>
            )}
          </button>
        )}
      </div>
      <pre className="code-block-content">
        <code className={`language-${language}`}>{code}</code>
      </pre>
    </div>
  );
}

export default CodeBlock;
